import axios from 'axios';
import { API_URL } from 'utils/http';

export function getClusterKey(userId, token) {
  return axios.post(`${API_URL}/cli/${userId}/key`, { token });
}
